import React, { useState } from "react";
import { Card, Dropdown } from "react-bootstrap";
import { FiCalendar } from "react-icons/fi";


const data = {
  Today: [
    {
      name: "Pitch",
      value: "$10,200",
      status: "Not Contacted",
      class: "badge-not",
      img: "/assets/img/company/company-01.svg",
    },
  ],
  "This Week": [
    {
      name: "Pitch",
      value: "$45,985",
      status: "Not Contacted",
      class: "badge-not",
      img: "/assets/img/company/company-01.svg",
    },
    {
      name: "Initech",
      value: "$21,145",
      status: "Closed",
      class: "badge-closed",
      img: "/assets/img/company/company-02.svg",
    },
    {
      name: "Umbrella Corp",
      value: "$15,685",
      status: "Contacted",
      class: "badge-contacted",
      img: "/assets/img/company/company-03.svg",
    },
    {
      name: "Capital Partners",
      value: "$12,105",
      status: "Contacted",
      class: "badge-contacted",
      img: "/assets/img/company/company-04.svg",
    },
    {
      name: "Massive Dynamic",
      value: "$2,546",
      status: "Lost",
      class: "badge-lost",
      img: "/assets/img/company/company-05.svg",
    },
  ],
  Month: [
    {
      name: "Pitch",
      value: "$75,000",
      status: "Closed",
      class: "badge-closed",
      img: "/assets/img/company/company-01.svg",
    },
    {
      name: "Initech",
      value: "$50,000",
      status: "Contacted",
      class: "badge-contacted",
      img: "/assets/img/company/company-02.svg",
    },
  ],
  Year: [
    {
      name: "Umbrella Corp",
      value: "$150,000",
      status: "Closed",
      class: "badge-closed",
      img: "/assets/img/company/company-03.svg",
    },
    {
      name: "Capital Partners",
      value: "$120,000",
      status: "Contacted",
      class: "badge-contacted",
      img: "/assets/img/company/company-04.svg",
    },
  ],
};

export default function LeadsByCompanies() {
  const [filter, setFilter] = useState("This Week");

  return (
    <Card className="leads-card task-card h-100">
      {/* Header */}
      <div className="leads-header card-header-custom">
        <h5>Leads By Companies</h5>

        <Dropdown>
          <Dropdown.Toggle className="filter-btn" size="sm">
            <FiCalendar className="me-1" />
            {filter}
          </Dropdown.Toggle>

          <Dropdown.Menu>
            {["Today", "This Week", "Month", "Year"].map((item) => (
              <Dropdown.Item
                key={item}
                active={filter === item}
                onClick={() => setFilter(item)}
              >
                {item}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>

      {/* List */}
      <div className="leads-body">
        {data[filter].map((c, i) => (
          <div key={i} className="company-row">
            <div className="company-left">
              <img src={c.img} alt="" />
              <div>
                <div className="company-name">{c.name}</div>
                <div className="company-value">Value : {c.value}</div>
              </div>
            </div>

            <span className={`status-badge ${c.class}`}>
              <span className="dot"></span>
              {c.status}
            </span>
          </div>
        ))}
      </div>
      <style>
          {

               `.leads-card {
  padding: 15px;
  border-radius: 5px;
  border: 2px solid #e5e7eb;
}
       .card-header-custom{
display:flex;
justify-content:space-between;
align-items:center;
padding:16px;
border-bottom:1px solid #eee;
background:#ffffff;


}

.card-header-custom h5{
margin:0;
font-size:18px;
font-weight:600;
color:#1f2937;
}

/* Header */
.leads-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.leads-header h5 {
  font-weight: 600;
  margin: 0;
}

/* Filter button */
.filter-btn {
  background: #fff;
  border: 1px solid #ddd;
  color: #333;
  font-size: 13px;
}

/* Body */
.leads-body {
  margin-top: 10px;
}

/* Row */
.company-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 9px;
  border: 1px dashed #e5e7eb;
  border-radius: 10px;
  margin-bottom: 10px;
  background: #fafafa;
}

/* Left */
.company-left {
  display: flex;
  align-items: center;
}

.company-left img {
  width: 40px;
  height: 40px;
  margin-right: 10px;
  border-radius: 50%;
  background: #fff;
  padding: 5px;
}

.company-name {
  font-weight: 500;
}

.company-value {
  font-size: 13px;
  color: #6b7280;
}

/* Status badges */
.status-badge {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 1px 7px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  color: #fff;
}

.status-badge .dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #fff;
}

/* Colors */
.badge-not {
  background: #a855f7;
}

.badge-closed {
  background: #22c55e;
}

.badge-contacted {
  background: #0f766e;
}

.badge-lost {
  background: #ef4444;
}
  @media (max-width:576px){
.task-card{
margin-top:15px;
}
}

@media (max-width:992px){
.task-card{
margin-top:15px;
}
}

@media (max-width:1024px){
.task-card{
margin-top:15px;
}
}
               `
          }
      </style>
    </Card>
  );
}